import React, { useEffect, useState } from "react";
import { crown } from "../../images";
import UpgradePremiumModal from "../pages/Layout/DashboardLayout/BillingDashboard/modals/UpgradePremiumModal";
import { useRazorpay } from "../context/RazorpayContext";
import { useBilling } from "../context/BillingContext";

const AllowedCard = () => {
  const [activeModal, setActiveModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);

  const { handlePreviewPlan } = useRazorpay();

  const { currentPlan, loading, refetchBilling, cancelDowngrade } =
    useBilling();

  useEffect(() => {
    const handleBillingUpdate = () => {
      refetchBilling();
    };

    window.addEventListener("billingUpdated", handleBillingUpdate);

    return () => {
      window.removeEventListener("billingUpdated", handleBillingUpdate);
    };
  }, []);

  const subscription = currentPlan?.subscription;

  const hasDowngrade =
    subscription?.plan_changes &&
    Object.keys(subscription?.plan_changes || {}).length > 0;

  const isSuspended = subscription?.status === "suspended";

  const isDowngradePending =
    hasDowngrade && subscription?.plan_changes?.downgrade;

  const planName =
    currentPlan?.name ||
    currentPlan?.subscription?.plan_name ||
    currentPlan?.subscription?.plan_changes?.name ||
    "Premium";

  const openModal = () => {
    setActiveModal(true);
  };

  const closeModal = () => {
    setActiveModal(false);
  };

  const handleRegeneratePaymentUrl = async (e) => {
    setIsLoading(true);

    try {
      await handlePreviewPlan(e, currentPlan?.id, "plan", false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelDowngrade = async () => {
    try {
      setCancelLoading(true);

      const res = await cancelDowngrade();

      if (res?.success) {
        refetchBilling();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setCancelLoading(false);
    }
  };

  const renderButton = () => {
    if (loading?.currentPlan) return null;

    if (isSuspended) {
      return (
        <button className="plan-btn" onClick={handleRegeneratePaymentUrl}>
          {isLoading ? (
            "Loading..."
          ) : (
            <>
              <i className="bi bi-rocket-takeoff me-1"></i>
              Continue Payment
            </>
          )}
        </button>
      );
    }

    if (hasDowngrade) {
      if (isDowngradePending) {
        return (
          <button
            className="btn-cancel-downgrade"
            onClick={handleCancelDowngrade}
          >
            {cancelLoading ? "Cancelling..." : "Cancel Downgrade"}
          </button>
        );
      }

      return (
        <a
          href={subscription?.plan_changes?.payment_link}
          className="plan-btn d-flex align-items-center justify-content-center text-decoration-none"
        >
          <i className="bi bi-rocket-takeoff me-1"></i>
          Continue Payment
        </a>
      );
    }

    return (
      <button className="plan-btn" onClick={openModal}>
        <i className="bi bi-arrow-right me-1"></i>
        Upgrade Plan
      </button>
    );
  };

  return (
    <>
      {activeModal && (
        <UpgradePremiumModal
          show={activeModal}
          openModal={openModal}
          onClose={closeModal}
        />
      )}

      <div className="card allowed-card w-100">
        <div className="allowed-card-content">
          <div className="allowed-card-image">
            <div className="glow"></div>

            <img
              src={crown}
              alt="crown"
              className="img-fluid"
              width={50}
              height={50}
            />
          </div>

          <h2 className="allowed-card-title">
            <i className="bi bi-star-fill me-2"></i>

            {isSuspended
              ? "Payment Pending"
              : isDowngradePending
                ? "Downgrade Scheduled"
                : `${planName}`}
          </h2>

          <p>
            {isSuspended
              ? "Your payment is pending. Continue payment to reactivate your subscription."
              : isDowngradePending
                ? "Your downgrade request is scheduled for the next billing cycle."
                : "Unlock premium marketplace insights and advanced dashboard features."}
          </p>

          {hasDowngrade && (
            <div className="plan-upgrade-alert">
              <i className="bi bi-info-circle-fill"></i>

              <div className="plan-upgrade-alert-content">
                <span className="plan-upgrade-alert-title">
                  {subscription?.plan_changes?.label}:{" "}
                  {subscription?.plan_changes?.name} (
                  {subscription?.plan_changes?.interval})
                </span>

                <span className="plan-upgrade-alert-text">
                  {subscription?.plan_changes?.message}
                </span>
              </div>
            </div>
          )}

          <div className="d-flex justify-content-center mt-1">
            {renderButton()}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllowedCard;
